module.exports = {
      id: "arcade-usage",
      viewBox: "0 0 19.915 20.731",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#arcade",
      toString: function () {
        return this.url;
      }
    }